module.exports = __webpack_public_path__ + "img/roboto-v27-latin-ext_latin-regular.4f862c8.svg";